import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { StakeDialogContentContainer } from './StakeDialogContentContainer'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

export interface StakeDialogBaseProps {
  onSuccess?: (spkStaked: NormalizedNumber) => void
  successViewProceedText?: string
  prefillWithMax?: boolean
}

export type StakeDialogProps = CommonDialogProps & StakeDialogBaseProps

function StakeDialog({ open, setOpen, ...props }: StakeDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <StakeDialogContentContainer closeDialog={() => setOpen(false)} {...props} />
      </DialogContent>
    </Dialog>
  )
}

export const stakeDialogConfig = {
  options: {
    closeOnAccountChange: true,
  },
  element: StakeDialog,
  name: 'StakeDialog',
} satisfies DialogConfig<StakeDialogProps>
